import React from 'react';
import { Modal } from 'react-bootstrap';

const TutorialModal = ({ show, handleClose}) => {

  const videoSrc ="https://www.youtube.com/embed/c--1AdTAS-4?autoplay=1&rel=0"

  return (
    <Modal show={show} onHide={handleClose}  dialogClassName="modal-xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Introduction to the BPMN-Chatbot++</Modal.Title>
      </Modal.Header>
      <Modal.Body className='m-2'>
            <iframe 
              style={{ width: '100%', height: '70vh' }}
              src={videoSrc} 
              title="YouTube video player" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              referrerPolicy="strict-origin-when-cross-origin" 
              allowFullScreen
            ></iframe>

      </Modal.Body>
    </Modal>
  );
};

export default TutorialModal;
